import { useState } from "react";
import { LinkIcon } from "@heroicons/react/24/outline";
import { toast } from "../../utils/toast";
import { Button, Card, Input } from "../ui";
import { bursariesApi } from "../../api/hliLists";
import { errorMessageOf } from "../../api/scholarships";
import { TOAST } from "./shared";

// One-time link between the signed-in account and the student's bursary record
export default function ClaimRecordCard({ onClaimed }) {
  const [regNumber, setRegNumber] = useState("");
  const [nationalId, setNationalId] = useState("");
  const [busy, setBusy] = useState(false);

  const claim = async (event) => {
    event.preventDefault();
    if (!regNumber.trim() || !nationalId.trim()) {
      toast.warning("Please, provide your registration number and national ID", TOAST);
      return;
    }
    setBusy(true);
    try {
      const { data } = await bursariesApi.claim({ registrationNumber: regNumber.trim(), nationalId: nationalId.trim() });
      toast.success("Your bursary record is now linked to your account", TOAST);
      onClaimed(data);
    } catch (error) {
      console.error("Failed to claim the bursary record", error);
      toast.error(errorMessageOf(error, "We could not verify your details. Please, check them and try again."), TOAST);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card
      className="max-w-xl"
      title="Claim your bursary record"
      subtitle="Link your account to your bursary record once, using your admission (registration) number and national ID. You need it to apply for a local loan, check your status or submit a claim."
    >
      <form onSubmit={claim} className="flex flex-col gap-5">
        <Input label="Registration number" required value={regNumber} onChange={(e) => setRegNumber(e.target.value)} />
        <Input label="National ID" required value={nationalId} onChange={(e) => setNationalId(e.target.value)} />
        <Button type="submit" loading={busy} icon={<LinkIcon className="h-4 w-4" />} className="self-start">
          Claim record
        </Button>
      </form>
    </Card>
  );
}
